import * as React from 'react';

export class EmptyStateSvg extends React.Component<{}> {

  render() {
    return (
      <svg
          width="82px"
          height="83px"
          viewBox="0 0 82 83"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g
            id="emoty-state-download-icon"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
          <g id="Group" transform="translate(1.000000, 2.000000)" stroke="#CAEDFA" strokeWidth="2">
            <polyline
                id="Stroke-1371"
                points="55.1665516 56.2971034 55.1665516 64.0929655 24.8249482 64.0929655 24.8249482 56.2971034"
            />
            <polygon
                id="Stroke-1372"
                points="79.9914999 80.6452414 0 80.6452414 0 55.8176552 24.8249482 55.8176552 24.8249482 64.0935172
                55.1665516 64.0935172 55.1665516 55.8176552 79.9914999 55.8176552"
            />
            <polyline id="Stroke-1373" points="0 55.8176552 13.9116252 42.0245517 26.0841248 42.0245517"/>
            <polyline
                id="Stroke-1374"
                points="79.9914999 55.8176552 66.0798747 42.0245517 57.3856262 42.0245517"
            />
            <path d="M41.3749137,42.0245517 L41.3749137,0.645241379" id="Stroke-1375"/>
            <polyline
                id="Stroke-1376"
                points="59.304043 25.4728276 41.3749137 42.0245517 23.4457845 25.4728276"
            />
          </g>
        </g>
      </svg>
    )
  }
}